import { render } from "./Register.vue?vue&type=template&id=3563ad7c"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3563ad7c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3563ad7c', __exports__)) {
    console.log('reload')
    api.reload('3563ad7c', __exports__)
  }
  
  module.hot.accept("./Register.vue?vue&type=template&id=3563ad7c", () => {
    console.log('re-render')
    api.rerender('3563ad7c', render)
  })

}


export default __exports__